import React from 'react';
import {connect} from 'react-redux';
import {Button, PasswordInput} from '../Presentation/Forms';
import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';
import Loader from '../Presentation/Loader';

import {resetPasswordAction} from '../../actions/Auth';
import {openSuccessPopup, openFailPopup} from '../../actions/Popup';
import {browserHistory} from 'react-router';

class ResetPassword extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            passwordRepError: ""
        };

        this.submit = this.submit.bind(this);
    }

    submit(e) {
        e.preventDefault();
        if (this.refs.password.validate()) {
            const {password, passwordRep} = this.getInputValues();

            if (password !== passwordRep) {
                this.setState({
                    passwordRepError: "Паролите не съвпадат"
                });
            }
            else {
                this.dispatchResetPassword(password, this.props.routeParams.token);
            }
        }

        return false;
    }

    dispatchResetPassword(password, token) {
        this.props.dispatch(resetPasswordAction(this.dispatchResetPassword.bind(this, password, token), {
            newPassword: password,
            token: token
        }))
            .then(() => {
                this.props.dispatch(openSuccessPopup({
                    title: "Честито",
                    text: "Успешно сменихме вашата парола"
                }));

                browserHistory.push('/login');
            })
            .catch(() => {
                this.props.dispatch(openFailPopup({
                    title: "Грешка",
                    text: "Възникна грешка по време смяната на паролата"
                }));

                browserHistory.push('/login');
            });

        this.setState({
            passwordRepError: ""
        });
    }

    getInputValues() {
        return {
            password: this.refs.password ? this.refs.password.getValue() : "",
            passwordRep: this.refs.passwordRep ? this.refs.passwordRep.getValue() : ""
        }
    }

    render() {
        const {password, passwordRep} = this.getInputValues();
        const {pending} = this.props;
        const {passwordRepError} = this.state;

        return <FullWidthPage title="Забравена парола">
            <form className="profile-form login">
                <div className="row">
                    <div className="col-md-6 col-md-offset-3">
                        <SectionTitle>Въведете новата си парола</SectionTitle>
                        <Loader show={pending}/>
                        <div className={pending ? "loading" : ""}>
                            <PasswordInput ref="password" value={password} id="password" name="password" required="required" label="Нова парола"/>
                            <PasswordInput error={passwordRepError} ref="passwordRep" value={passwordRep} id="passwordRep" name="passwordRep" required="required" label="Повтори паролата"/>
                            <div className="text-center">
                                <Button clickHandler={this.submit} text="Запази"/>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {
        pending: state.auth.forgottenPasswordPending,
        credentialsError: state.auth.loginError
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(ResetPassword);


// WEBPACK FOOTER //
// ./src/components/Pages/ResetPassword.js